/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var NoteStatusIcon = createIcon("NoteStatusIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16H1.328A1.332 1.332 0 010 14.663V1.337C0 .598.598 0 1.337 0h13.326C15.402 0 16 .596 16 1.328V10l-6 6Z",
    fill: "#FFEC44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16 10-6 6v-4.668c0-.736.597-1.332 1.332-1.332H16Z",
    fill: "#987B12"
  }));
}, {});